import { Type } from 'class-transformer';
import { KeyValueResultDto } from '../../../../../_models/key-value-result-dto';
import { FileInfoDisplayResultDto } from '../../../../../_models/file-info-display-result-dto';
import { UpdatedResultDto } from '../../common/updated-result-dto';

export class APPaymentResultDto {
    paymentId: number;
    paymentNumber: string;

    @Type(() => Date)
    paymentDate: Date;

    @Type(() => Date)
    postDate: Date;

    @Type(() => Date)
    clearDate: Date;

    vendorName: string;
    description: string;
    paymentMethod: string;
    amount: number;
    unappliedAmount: number;
    status: string;
    accountName: string;
    paymentType: string;
    voided: boolean;
    isReconciled: boolean;

    allowVoidPayment: boolean;
    allowUpdatePaymentPostDate: boolean;
    allowReclassify: boolean;
    allowAddCharge: boolean;

    @Type(() => UpdatedResultDto)
    lastUpdated: UpdatedResultDto;

    @Type(() => FileInfoDisplayResultDto)
    paymentDocument: FileInfoDisplayResultDto;

    @Type(() => KeyValueResultDto)
    requiredDimensions: KeyValueResultDto[];
}
